module.exports = __webpack_public_path__ + "img/logo_big.f98f507c.png";